import { Link } from "react-router-dom";
import { GiClick } from "react-icons/gi";

export const ContactButton = () => {
  return (
    <Link
      to="/wizard"
      className="relative inline-flex items-center justify-center w-full text-black  text-lg md:text-2xl py-6 px-5 rounded  m-auto overflow-hidden shadow-black shadow-2xl group bg-white border border-[#002b5b] transition-colors duration-300"
    >
      {/* テキスト & アイコン */}
      <span className="relative z-10 group-hover:text-white transition-colors duration-300 whitespace-nowrap">
        クリックで最適なカメラを探す
        <GiClick className="inline text-3xl ml-2 align-middle" />
      </span>

      {/* カットイン背景 */}
      <span className="absolute inset-0 bg-[#002b5b] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out"></span>

      {/* ホバー時の白い枠線 */}
      <span className="absolute inset-0 border border-white group-hover:opacity-100 opacity-0 rounded transition-opacity duration-300 z-0"></span>
    </Link>
  );
};
